export default __webpack_public_path__ + "static/media/14-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.246126f3.jpg";